module.exports = __webpack_public_path__ + "img/蒙版组 149.9cc73073.png";